<div class="flex justify-center">
    <div
        class="relative flex items-center justify-center"
        [style.width]="size()"
        [style.height]="size()">
        @for (i of loop; track index; let index = $index) {
            <div
                class="absolute box-border block animate-loader-ring-animation rounded-full"
                [style.width]="innerSize()"
                [style.height]="innerSize()"
                [style.border]="border()"
                [style.border-color]="borderColor()"
                [class.delay-[-0.45s]]="index === 0"
                [class.delay-[-0.3s]]="index === 1"
                [class.delay-[-0.15s]]="index === 2"></div>
        }
    </div>
</div>
